import { useEffect, useState } from 'react'
import styles from './Hero.module.css'

const SHORTLIST = [
  { initials: 'MH', name: 'M. Harris', role: '6 yrs · Wellington', match: 94 },
  { initials: 'RT', name: 'R. Tane', role: '4 yrs · Remote NZ', match: 89 },
  { initials: 'SC', name: 'S. Chen', role: '8 yrs · Auckland', match: 85 },
]

export default function Hero() {
  const [filled, setFilled] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => setFilled(true), 500)
    return () => clearTimeout(timer)
  }, [])

  return (
    <section className={styles.hero} id="top">
      <div className={`container ${styles.grid}`}>
        <div className={styles.copy}>
          <p className={styles.kicker}>AI recruitment, built for Aotearoa</p>
          <h1 className={styles.heading}>
            Your next great hire,
            <br />
            shortlisted by Friday.
          </h1>
          <p className={styles.subtext}>
            Virtual Recruiter pairs AI-driven matching with recruiters based
            right here in New Zealand — so you spend less time screening CVs
            and more time talking to the right people.
          </p>
          <div className={styles.actions}>
            <a href="#post-role" className={styles.primary}>Post a role</a>
            <a href="#candidates" className={styles.secondary}>I'm looking for work</a>
          </div>
          <p className={styles.fineprint}>
            No placement, no fee. Trusted by teams from Kerikeri to Invercargill.
          </p>
        </div>

        <div className={styles.visual} aria-hidden="true">
          <div className={styles.card}>
            <div className={styles.cardHead}>
              <span className={styles.cardRole}>Senior Frontend Engineer</span>
              <span className={styles.cardLoc}>Wellington · Hybrid</span>
            </div>
            <ul className={styles.cardList}>
              {SHORTLIST.map((c) => (
                <li key={c.initials} className={styles.cardRow}>
                  <span className={styles.avatar}>{c.initials}</span>
                  <span className={styles.rowInfo}>
                    <span className={styles.rowName}>{c.name}</span>
                    <span className={styles.rowMeta}>{c.role}</span>
                  </span>
                  <span className={styles.matchWrap}>
                    <span className={styles.matchBarTrack}>
                      <span
                        className={styles.matchBarFill}
                        style={{ width: filled ? `${c.match}%` : 0 }}
                      />
                    </span>
                    <span className={styles.matchNum}>{c.match}%</span>
                  </span>
                </li>
              ))}
            </ul>
            <div className={styles.cardFoot}>Ranked by fit, reviewed by a human</div>
          </div>
        </div>
      </div>
    </section>
  )
}
